import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import {useNavigate, useParams} from "react-router-dom";
import {useMutation} from "@apollo/react-hooks";
import {IModalProps} from "../../../../libs/uiKit/modal/types";
import FormModal from "../../../widgets/FormModal";
import useNotification from "../../../widgets/notifier/ui/hooks/useNitification";
import {
  AddendumMutation,
  AddendumMutationVariables,
  AddendumReasonEnum,
  CrossMutation, CrossMutationVariables, DictKeyEnum
} from "../../../../libs/api/graphqlTypes";
import {ADDENDUM, CROSS, SEARCH_AGREEMENT} from "../../../../libs/api/commands";
import {formatDateToStringRu} from "../../../../libs/utils/gormatDateToUsa";
import useGetDicti from "../../common/hooks/useGetDicti";
import {FieldsBuilder} from "../../../../libs/uiKit/fieldsBuilder";
import {StyledButtonsGroup} from "./sendPayLinkModal/styles";
import Button from "../../../../libs/uiKit/button";
import {Modal} from "../../../../libs/uiKit/modal";
import {IForm} from "../../../../libs/uiKit/fieldsBuilder/types";
import {useForm} from "react-hook-form";
import {StyledCrossResult, StyledRemark} from "./styles";
import {StyledBigPremiumHeader, StyledGrayLabel} from "../ui/styles";
import {stringToMoney} from "../../../../libs/uiKit/utils";
import {StyledAgrInfoLine} from "../../contract/ui/styles";
import {useGlobalContext} from "../../../../apps/main/ui/GlobalContext";


const CrossModal = (props: IModalProps) => {

  const { id } = useParams<{ id?: string }>();

  const formHook = useForm({mode: "onBlur"});

  const {
    routes: { crossContractById },
  } = useGlobalContext();

  const navigate = useNavigate();

  const { data, isOpen } = props;
  const { dateBegin, finalButtonLabel, risks, searchMode } = data;

  const interiorDefault = (risks || []).find((item: any) => item.type === "Отделка")?.limit_sum;
  const responsibilityDefault = (risks || []).find((item: any) => item.type === "ГО")?.limit_sum;
  const propertyDefault = (risks || []).find((item: any) => item.type === "Мебель")?.limit_sum;

  const [lastInterior, setLastInterior] = useState<string | undefined>(interiorDefault ? String(interiorDefault) : undefined);
  const [lastResponsibility, setLastResponsibility] = useState<string | undefined>(responsibilityDefault ? String(responsibilityDefault) : undefined);
  const [lastProperty, setLastProperty] = useState<string | undefined>(propertyDefault ? String(propertyDefault) : undefined);

  useEffect(() => {
    if (interiorDefault) {
      formHook.setValue("interior", {
        label: String(interiorDefault),
        value: String(interiorDefault)
      });
    }
    if (responsibilityDefault) {
      formHook.setValue("responsibility", {
        label: String(responsibilityDefault),
        value: String(responsibilityDefault)
      });
    }
    if (propertyDefault) {
      formHook.setValue("property", {
        label: String(propertyDefault),
        value: String(propertyDefault)
      });
    }
  }, [isOpen]);


  const {setNotification} = useNotification();

  const { data: propertySums, loading: loadingPropertySums } = useGetDicti(DictKeyEnum.CrosssaleProperty);
  const { data: propertyInteriors, loading: loadingPropertyInteriors } = useGetDicti(DictKeyEnum.CrossaleInterior);
  const { data: propertyResponsibilities, loading: loadingPropertyResponsibilities } = useGetDicti(DictKeyEnum.CrossaleResponsibility);

  const [statePremiumSum, setStatePremiumSum] = React.useState<number|undefined>(undefined);
  const [stateRegister, setStateRegister] = React.useState<boolean>(false);
  const [agrData, setAgrData] = useState<any>(null);

  const [cross, {loading: loadingCross}] = useMutation<CrossMutation, CrossMutationVariables>(CROSS, {
    refetchQueries: ['loadContract', 'loadAgreementUnderwriting'], awaitRefetchQueries: true
  });

  const [searchAgreement, {loading: loadingSearchAgreement}] = useMutation(SEARCH_AGREEMENT);

  const onSubmit = (formData: any) => {

    const isn  = agrData ? agrData.isn : null;

    if(!id && !isn) return;

    cross({
      variables: {
        id: parseInt(id || "", 10),
        isn,
        date_sign: formatDateToStringRu(formData.date),
        responsibility: parseInt(formData.responsibility?.value, 10),
        interior: parseInt(formData.interior?.value, 10),
        property: parseInt(formData.property?.value, 10),
        register: stateRegister,
      }
    }).then((data) => {
      if(stateRegister) {
        setStateRegister(false);
        setStatePremiumSum(undefined);
        props.onClose();
        if(isn){
          navigate(crossContractById(String(data.data?.cross)))
        }
      } else {
        setStatePremiumSum(data.data?.cross || 0);
        setLastInterior(formData.interior?.value);
        setLastResponsibility(formData.responsibility?.value);
        setLastProperty(formData.property?.value);
      }
    })
      .catch(error => setNotification({type: "error", text: error}))
  }

  const searchHandler = () => {
    const number = formHook.getValues('searchNumber');
    searchAgreement({
      variables: {
        number
      }
    }).then((data) => {
      setAgrData(data?.data?.searchAgreement);
    }).catch(error => setNotification({type: "error", text: error}))
  }

  const onFormSubmit = formHook.handleSubmit(onSubmit)

  const [interior, property, responsibility, dateBeginValue] = formHook.watch(["interior", "property", "responsibility", "date"]);

  const isCalculated = (statePremiumSum !== undefined);

  const isChanged = (
      (lastInterior || interior?.value) && lastInterior !== interior?.value
      || (lastResponsibility || responsibility?.value) && lastResponsibility !== responsibility?.value
      || (lastProperty || property?.value) && lastProperty !== property?.value
  );

  useEffect(() => {
      if(!dateBeginValue){
          formHook.setValue("date", dayjs().add(5, 'day').toDate());
      }
  }, []);

  useEffect(() => {
    if(!interior){
      formHook.setValue('property', null);
    }
  }, [interior]);

  const form: IForm = {
    formHook,
    hotReload: true,
    fields: [
      {
        isHidden: !searchMode || agrData,
        field: {
          fieldName: "searchNumber",
          fieldType: "input",
          placeholder: "Номер ипотечного договора",
          isRequired: true,
        }
      },
      {
        isHidden: searchMode && !agrData,
        field: {
          fieldName: "interior",
          fieldType: "select",
          isLoading: loadingPropertyInteriors,
          errorMessage: "Выберите сумму",
          placeholder: "Внутренняя отделка",
          items: propertyInteriors,
          isClearable: true,
          /*defaultValue: interiorDefault ? {
            label: String(interiorDefault),
            value: String(interiorDefault)
          } : undefined,*/
        }
      },
      {
        isHidden: searchMode && !agrData,
        field: {
          fieldName: "responsibility",
          fieldType: "select",
          isLoading: loadingPropertyResponsibilities,
          errorMessage: "Укажите сумму",
          placeholder: "Гражданская ответственность",
          items: propertyResponsibilities,
          isClearable: true,
        }
      },
      {
        isHidden: searchMode && !agrData,
        field: {
          fieldName: "property",
          fieldType: "select",
          isLoading: loadingPropertySums,
          errorMessage: "Укажите сумму",
          placeholder: "Движимое имущество",
          items: propertySums,
          isClearable: true,
          isDisabled: !interior,
        }
      },
      {
        isHidden: (!dateBegin || searchMode) && !agrData,
        field: {
          fieldName: "date",
          fieldType: "date",
          validationType: "minMaxDate",
          minDate: dayjs().add(5, 'day').toDate(),
          maxDate: dayjs().add(90, 'day').toDate(),
          errorMessage: "Выберите дату",
          placeholder: "Начало действия договора",
          isRequired: true,
          grid: 6,
        }
      },
    ]
  };

  return (
    <Modal {...props} header="Застраховать дополнительные риски" isLoading={false}>
      <form onSubmit={onFormSubmit}>
        {searchMode && <StyledRemark>
          Создать договор добровольного страхования имущества. Сведения о страхователе и объекте страхования использовать из договора ипотечного страхования:
        </StyledRemark>}
        {agrData && <div>
          <StyledAgrInfoLine>
            <p>Номер договора:</p><p>{agrData.policy_no}</p>
          </StyledAgrInfoLine>
          <StyledAgrInfoLine>
            <p>Дата начала:</p><p>{agrData.date_begin}</p>
          </StyledAgrInfoLine>
          <StyledAgrInfoLine>
            <p>Дата окончания:</p><p>{agrData.date_end}</p>
          </StyledAgrInfoLine>
          <StyledAgrInfoLine>
            <p>Продукт:</p><p>{agrData.product_name}</p>
          </StyledAgrInfoLine>
          <StyledAgrInfoLine>
            <p>Имя страхователя:</p><p>{agrData.policy_holder?.lastname} {agrData.policy_holder?.firstname} {agrData.policy_holder?.parentname}</p>
          </StyledAgrInfoLine>
          <br/><br/>
        </div>}
        <FieldsBuilder {...form}/>
        {isCalculated && <>
          <StyledGrayLabel>Страховая премия</StyledGrayLabel>
          <StyledBigPremiumHeader style={{fontSize: '3rem'}}>{stringToMoney(statePremiumSum)} RUB</StyledBigPremiumHeader>
          <br/>
        </>}
        <StyledButtonsGroup style={{gridTemplateColumns: isCalculated ? "1fr 1fr" : "1fr 1fr"}}>
          <Button appearance="transparent" onClick={() => {
            setStateRegister(false);
            setStatePremiumSum(undefined);
            setAgrData(null);
            props.onClose();
          }}>Отменить</Button>
          {searchMode && !agrData && <Button
              isLoading={loadingSearchAgreement}
              appearance="filled"
              type="button"
              onClick={() => searchHandler()}>
            Продолжить
          </Button>}
          {(!isCalculated || isCalculated && isChanged) && !(searchMode && !agrData) &&
            <Button
              isLoading={loadingCross}
              appearance="filled"
              type="submit"
              isDisabled={!interior && !property && !responsibility || !isChanged}
              onClick={() => setStateRegister(false)}>
              Рассчитать
            </Button>
          }
          {isCalculated && !isChanged && !(searchMode && !agrData) && <Button isLoading={loadingCross} appearance="filled" type="submit" onClick={() => setStateRegister(true)}>
            {finalButtonLabel || " Создать договор"}
          </Button>}
        </StyledButtonsGroup>
      </form>
    </Modal>
  );
}

export default CrossModal;